
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videosiderRight\" id=\"js_siderRight\">\n    <div class=\"videosiderRightBg\"></div>\n    <div class=\"videosiderRightContent\">\n        <div class=\"siderRightShare\" id=\"js_siderRight_share\">\n            <div class=\"shareTip\">分享到微信</div>\n            <img src=\"http://qrcode.ifeng.com/2016/08/01/1fed05e73fed1a4a4353702af9ef39a0.png\" id=\"js_siderRight_shareImg\" />\n            <ul class=\"shareBtns js_siderShare_trigger\">\n                <li class=\"btn1\" data-tag=\"sinateew\"></li>\n                <li class=\"btn2\" data-tag=\"qqteew\"></li>\n                <li class=\"btn3\" data-tag=\"qqzone\"></li>\n            </ul>\n            <div class=\"copyTip\">复制转帖</div>\n            <textarea id=\"js_copy_text\" style=\"width: 0px;height: 0px;opacity: 0\"></textarea>\n            <ul class=\"copyBtns js_siderCopy_trigger\">\n                <li class=\"btn1\" data-tag=\"url\" data-text=\"播放地址\">播放地址</li>\n                <li class=\"btn2\" data-tag=\"mp4\" data-text=\"Mp4地址\">Flash地址</li>\n                <li class=\"btn3\" data-tag=\"html\" data-text=\"Html地址\">Html代码</li>\n            </ul>\n        </div>\n        <div class=\"siderRightDown\" id=\"js_siderRight_down\">\n            <a href=\"http://v.ifeng.com/apps/index.shtml\" target=\"_blank\">\n                <img src=\"http://y3.ifengimg.com/a/2015/0831/download.jpg\" alt=\"\" title=\"凤凰新闻客户端\">\n            </a>\n            <div class=\"downTip\">下载客户端观看</div>\n        </div>\n        <div class=\"siderRightList\" id=\"js_siderRight_menu\">\n            <div class=\"listPosition\" id=\"js_listPosition\">\n                <ul id=\"js_siderRight_list\">\n                </ul>\n                <div class=\"scrollbar\">\n                    <div class=\"scroller\" id=\"js_siderRight_scroller\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"videosiderRightClose\">\n            <div class=\"closeBtn\" data-tag=\"siderRightclose\" id=\"js_siderRight_close\"></div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./components/f.component.video.pc/app/modules/list/main.ejs
// module id = 1uPB
// module chunks = 0